<template>
  <div
    class="kk-design__font-item"
    :style="{ fontFamily: fontname }"
    :data-test-id="`font-item-${fontname.replace(/\s+/g, '-').toLowerCase()}`"
    @click="selectFont"
    @keydown.enter="selectFont"
  >
    {{ fontname }}
  </div>
</template>
<script>
export default {
  props: ["fontname"],
  emits: ["select-font"],
  methods: {
    selectFont() {
      this.$emit("select-font", this.fontname);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";

.kk-design {
  &__font-item {
    cursor: pointer;
    padding: 0.2rem;
    &:hover {
      background-color: @kk-color-light-blue;
    }
  }
}
</style>
